import { type Request } from '../interface/Crash';
import { type HAR, type HARItem, type HARRequest, type NameValue } from '../interface/Har';

export const convertCrashToHar = (requests: Request[]): HAR => {
    const result: HAR = {
        log: {
            version: '1.2',
            creator: {
                name: 'Outbank ServicePortal',
                version: '1.0.1',
            },
            browser: {
                name: 'Webconnect',
                version: '1',
            },
            pages: [
                {
                    startedDateTime: '',
                    id: '',
                    title: '',
                },
            ],
            entries: processRequests(requests ?? []),
        },
    };

    return result;
};

const getHeaderByKey = (headers: any, key: string): string[] => {
    let result = [];
    if (!Array.isArray(headers)) {
        Object.keys(headers ?? {})
            .filter((headerKey) => headerKey.toLowerCase() === key.toLowerCase())
            .forEach((headerKey) => result.push(headers[headerKey]));
    } else {
        result = headers?.find((item: string[]) => item[0].toLowerCase() === key.toLowerCase());
    }
    return !result ? [] : result;
};

const processRequests = (requests: Request[]): HARItem[] => {
    const result: HARItem[] = [];
    for (const request of requests) {
        // Check for Websocket
        const isWSS = request.url.startsWith('wss');
        const response = request.response;
        let cookies = [];
        if (isWSS) {
            cookies = ['Cookie', (request.headers.cookie ?? '').trim()];
        } else {
            cookies = getHeaderByKey(request.headers, 'cookie') ?? [];
        }

        const responseHeaders = response?.headers ?? {};
        let responseCookies: string[] | undefined = [];
        if (isWSS) {
            responseCookies = [];
        } else {
            if (response?.headers) {
                responseCookies = getHeaderByKey(response.headers, 'set-cookie') ?? [];
            }
        }
        const responseCookiesHar: NameValue[] = [];
        responseCookies?.forEach((item: any) => {
            const splitted = item.split(';');
            if (splitted) {
                const someValue = splitted[0].split('=');
                if (someValue.length === 2) {
                    responseCookiesHar.push({
                        name: someValue[0].trim(),
                        value: someValue[1].trim(),
                    });
                }
            }
        });
        const responseHeadersHar: NameValue[] = [];
        Object.entries(responseHeaders).forEach(([name, value]) => {
            if (!['__id__', '__class__'].includes(name)) {
                responseHeadersHar.push({
                    name,
                    value,
                });
            }
        });

        let requestContentTypeHar = '';
        let requestHeadersHar: any[] = [];
        if (isWSS) {
            requestHeadersHar = Object.keys(request.headers)
                .map((key) => {
                    if (['__id__', '__class__'].includes(key)) {
                        return undefined;
                    }
                    return {
                        name: key,
                        value: request.headers[key].toString(),
                    };
                })
                .filter((item) => item !== undefined);
        } else {
            if (!Array.isArray(request.headers)) {
                Object.keys(request.headers ?? {}).forEach((headerKey) => {
                    if (headerKey.toLowerCase() === 'content-type') {
                        requestContentTypeHar = request.headers[headerKey];
                    }
                    if (!['__id__', '__class__'].includes(headerKey)) {
                        requestHeadersHar.push({
                            name: headerKey,
                            value: request.headers[headerKey].toString(),
                        });
                    }
                });
            } else {
                requestHeadersHar = request.headers?.map((item: any) => {
                    if (item[0].toLowerCase() === 'content-type') {
                        requestContentTypeHar = item[1];
                    }
                    return {
                        name: item[0],
                        value: `${item[1].toString()}`,
                    };
                });
            }
        }

        const createHARObject = (item: any): any => {
            return {
                name: item[0],
                value: `${item[1]}`,
            };
        };

        const responseBody = response?.body;
        const _request: HARRequest = {
            headers: requestHeadersHar,
            method: request.method,
            url: request.url,
            cookies: !cookies ? [] : cookies.map((item: any) => createHARObject(item)),
        };

        if (request.data) {
            let _text: string;
            try {
                _text = decodeURI(window.atob(request.data.bytes));
            } catch (error) {
                _text = window.atob(request.data.bytes);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _tmpPostData: any = {
                mimeType: requestContentTypeHar,
                text: _text,
            };
            if (requestContentTypeHar.includes('form-urlencoded')) {
                const params = _text.split('&').map((item) => {
                    return {
                        name: item[0],
                        value: item[1],
                    };
                });

                if (params) _tmpPostData.params = params;
            }
            _request.postData = _tmpPostData;
        }

        const _response = {
            status: response?.code ?? 0,
            statusText: 'OK',
            headers: responseHeadersHar,
            cookies: responseCookiesHar,
            content: {
                mimeType: responseBody ? responseBody.content_type : '',
                text: responseBody ? window.atob(responseBody.bytes) : '',
            },
        };

        result.push({
            startedDateTime: request.response?.headers?.date ?? '',
            request: _request,
            response: _response,
            // Firefox need this timings object, but we need no content
            cache: {},
            timings: {},
        });
    }
    return result;
};
